<div class="config-container shadow my-3" *ngFor="let plan of plans">
  <h4 class="title configurator-subtitle collapse-button" (click)="togglePlanCollapse(plan.displayOrder)">
    {{ 'workbench.finishes.cutting.plan-number' | translate }} {{ plan.displayOrder }}
  </h4>

  <div class="collapse-block" *ngIf="selectedPlanIndex === plan.displayOrder">
    <button class="cutting-add-button" (click)="addConfigurationCutting()">
      + {{ 'workbench.finishes.cutting.add' | translate }}
    </button>

    <div class="config-container shadow my-3" *ngFor="let planCutting of plan.configurationCuttings; let index = index">
      <h4 class="title configurator-subtitle collapse-button" (click)="toggleCuttingCollapse(planCutting.displayOrder)">
        {{ 'workbench.finishes.cutting.cutting-number' | translate }} {{ planCutting.displayOrder }}
      </h4>

      <div class="collapse-block" *ngIf="selectedPlanCuttingIndex === planCutting.displayOrder">
        <div class="container-fluid">
          <div class="row">
            <div class="configurator-cards-container">
              <div
                class="configurator-card"
                *ngFor="let cutting of cuttings"
                [ngClass]="{
                  active: isCuttingSelected(cutting.id),
                }"
                (click)="selectCutting(cutting)">
                <ng-casto-img-loader
                  [imgSrc]="workbenchService.apiUrl + cutting.icon.path"
                  [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
                <p class="configurator-card-title">{{ cutting.name }}</p>
              </div>
            </div>
            <ng-casto-loader *ngIf="cuttings == null"></ng-casto-loader>
          </div>
          <div class="cutting-delete align-right" *ngIf="cuttings != null">
            <button (click)="deleteCutting(index)" class="cutting-delete-button">
              <svg>
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/img/icons.svg#icon-action-delete"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
